import {
	CONTENT_ERROR,
	FORBIDDEN_ERROR,
	STAGES_REQUEST,
	ACCOUNTS_REQUEST,
	CURRENCIES_REQUEST,
	COUNTRIES_REQUEST,
	SCHOOLTYPES_REQUEST,
	CLASSROOMS_REQUEST,
    TEACHERS_REQUEST } 	from '../actions/contentActions'
import { LOG_OUT } 	from '../actions/authActions'
import { push } 		from 'react-router-redux'

const contentMiddleware = store => next => action => {
    switch (action.type) {
        /* case STAGES_REQUEST:
            store.dispatch(push('/admin/stages/'));
            break;
        case ACCOUNTS_REQUEST:
            store.dispatch(push('/admin/accounts/'));
            break;
        case CURRENCIES_REQUEST:
            store.dispatch(push('/admin/settings/currency'));
            break;
        case COUNTRIES_REQUEST:
            store.dispatch(push('/admin/settings/countries'));
            break;
        case SCHOOLTYPES_REQUEST:
            store.dispatch(push('/admin/settings/school-types'));
            break;
        case CLASSROOMS_REQUEST:
            store.dispatch(push('/admin/school/class-rooms'));
            break;
        case TEACHERS_REQUEST:
            store.dispatch(push('/admin/school/teachers'));
            break; */
        case CONTENT_ERROR:
        case FORBIDDEN_ERROR:
            //store.dispatch({ type: LOG_OUT });
            break;
        default:
            break;
    }
    next(action);
}

export default contentMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/contentMiddleware.js